import { t } from '@lingui/core/macro';
import { type ToastOptions } from 'app-ui/components';

import { getUserFriendlyErrorMessage } from '@/apollo/utils/getUserFriendlyErrorMessage';

type GetToastOptionsFromErrorArgs = {
  error: unknown;
};

// The dedupe key is the message itself: an unexpected error is shown by the
// error link and again by the screen that ran the action, and must still
// appear once.
export const getToastOptionsFromError = ({
  error,
}: GetToastOptionsFromErrorArgs): ToastOptions => {
  const message = getUserFriendlyErrorMessage(error) ?? t`An error occurred.`;

  return { variant: 'error', children: message, dedupeKey: message };
};
